import React, { useMemo, useState } from 'react';
import { Row, Col, BgIcon } from 'components';
import { COLORS } from 'const';
import { Input, Tabs } from 'antd';
import { ORDER_STAGE } from 'store/Order.Store';
import { ValHelper } from 'helpers';
import { useUserStore } from 'store/User.Store';

export const TABS = [
  { title: 'Pending Jobs', key: 'Pending', tooltip: 'These jobs have come through and need your attention' },
  { title: 'In Production Jobs', key: 'Accepted', tooltip: 'These jobs have been accepted and are being printed' },
  { title: 'Fulfilled Jobs', key: 'Fulfilled', tooltip: 'These jobs have all been dispatched' },
  { title: 'Rejected Jobs', key: 'Rejected', tooltip: 'If you job falls outside of the IT Luggage T&C, ITL will reject the job' },
];

export const useOrderTabs = () => {
  const [tab, setTab] = useState<'Pending' | 'Accepted' | 'Fulfilled'>('Pending');
  return [tab, setTab];
}

export const ListOrdersTabs = ({ activeTab, onChangeTab, searchPlaceholder, onSearchInput, renderAction, ...props }) => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const activeKey = ValHelper.toDisplayStage(activeTab);
  const UserStore = useUserStore();

  const items = useMemo(() => {
    const arr = [{ key: "All", label: "All" }].concat(
      ORDER_STAGE.map(i => ({ key: i, label: i }))
    );
    if (UserStore?.user?.role === "admin") {
      arr.push({ key: "Recycling Bin", label: "Recycling Bin" });
    }
    return arr;
  }, [UserStore]);

  return (
    <Row flexWrap="wrap" alignItems="center" justifyContent="space-between" {...props}>
      <Tabs
        defaultActiveKey={items[0].key}
        activeKey={activeKey}
        items={items}
        onChange={onChangeTab}
      />
      {renderAction}
      <Col width={282} marginBottom={8}>
        <Input
          value={searchKeyword}
          size="middle"
          placeholder={searchPlaceholder}
          prefix={(
            <Col marginBottom={-4}>
              <BgIcon name="search" size={18} color={COLORS.ICON_MUTED} />
            </Col>
          )}
          onChange={(e) => setSearchKeyword(e.target.value)}
          onPressEnter={() => {
            onSearchInput(searchKeyword);
          }}
        />
      </Col>
    </Row>
  )
};
